import React, { Fragment, useEffect, useState } from 'react'
import { FormControl, FormControlLabel, Radio, TextField } from '@mui/material';
import UploadDocButton from './UploadDocButton';
import { alphaNumeric } from '../../../../../../commonClass/CommonValidation';
import { CommonFileURLWithFolder } from '../../../../../../../ImageUpload/ImageCommon';

const Legal = (props) => {

    const {
        formError,
        setFormError,
        imageSection,
        setImageSection,
        formValue,
        setFormValue,
        handleDeleteFile,
        hotelId,
        disabled,
        setSave,
        removerError } = props;

    const hendlesetdoc = (name, path, val) => {
        removerError('legalfinance-tab-0')
        setFormError({})
        setSave(false)
        setFormValue(prevState => ({ ...prevState, Legal: { ...prevState.Legal, [name]: val?.[0]?.FileName, [path]: val?.[0]?.FilePath } }));
    }

    const handleChange = (name, val) => {
        removerError('legalfinance-tab-0')
        setFormError({})
        setSave(false)
        if (name === 'IsGST' && val === false) {
            setFormValue(prevState => ({ ...prevState, Legal: { ...prevState.Legal, [name]: val, GSTFileName: "", GSTFilePath: "", GSTNo: "" } }));
            setImageSection([...imageSection?.filter(er => er.fieldname !== 'GSTFileName')])
        }
        else {
            setFormValue(prevState => ({ ...prevState, Legal: { ...prevState.Legal, [name]: val } }));
        }
    }

    const [onPhotoHover, setOnPhotoHover] = useState('');
    const doctest = (FileName) => {
        return /\.(png)$/i.test(FileName)
    }

    return (
        <div className='mt-3'>
            <div className='mt-3'>
                <h5>Property Document</h5>
                <div className='row'>
                    <div className='col-xl-3 col-lg-4 col-md-6 col-12'>
                        <div className='h-241px' key={'PropertyDocumentFileName'}>
                            <UploadDocButton
                                mediaType={".png,.pdf"}
                                name={'Document'}
                                foldername={'Property Document'}
                                iscollection={false}
                                maxfilesize={20}
                                Fieldname='PropertyDocumentFileName'
                                Fieldpath='PropertyDocumentFilePath'
                                hendlesetdoc={hendlesetdoc}
                                setImageSection={setImageSection}
                                formValue={formValue}
                                hotelId={hotelId}
                                disabled={disabled}
                                setSave={setSave}
                                setFormError={setFormError}
                            />
                        </div>
                        {formError?.PropertyDocumentFileName && <div className='text-danger'>{formError?.PropertyDocumentFileName}</div>}
                    </div>
                    {
                        imageSection?.filter(er => er.fieldname === 'PropertyDocumentFileName').map((img, index) => {
                            return (
                                <Fragment key={img?.fieldname + img?.FileName + index}>
                                    <div className='col-xl-3 col-lg-4 col-md-6 col-12'
                                        onMouseEnter={() => setOnPhotoHover(img?.fieldname)}
                                        onMouseLeave={() => setOnPhotoHover('')}
                                    >
                                        <div className='h-241px photo-images-card position-relative'>
                                            {doctest(img?.FileName) ?
                                                <img
                                                    className='rounded'
                                                    src={
                                                        img?.needToUpload ?
                                                            URL.createObjectURL(img?.File) :
                                                            `${CommonFileURLWithFolder}${img?.FilePath}`
                                                    }
                                                    alt={img?.FileName}
                                                    height={'100%'}
                                                    width={'100%'}
                                                    aspect-ratio={3 / 2}
                                                />
                                                :
                                                <div className='align-content-center px-auto photo-images-card' style={{ backgroundColor: '#0777a926', height: '100%', width: '100%' }} aspect-ratio={3 / 2}>
                                                    <div className='p-3'>
                                                        <span className='d-flex justify-content-center bg-transparent'>
                                                            <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M3.83333 34.1248C2.91667 34.1248 2.13194 33.7984 1.47917 33.1457C0.826389 32.4929 0.5 31.7082 0.5 30.7915V7.45817C0.5 6.5415 0.826389 5.75678 1.47917 5.104C2.13194 4.45123 2.91667 4.12484 3.83333 4.12484H10.8333C11.1944 3.12484 11.7986 2.31928 12.6458 1.70817C13.4931 1.09706 14.4444 0.791504 15.5 0.791504C16.5556 0.791504 17.5069 1.09706 18.3542 1.70817C19.2014 2.31928 19.8056 3.12484 20.1667 4.12484H27.1667C28.0833 4.12484 28.8681 4.45123 29.5208 5.104C30.1736 5.75678 30.5 6.5415 30.5 7.45817V18.6248C29.9722 18.3748 29.4306 18.1596 28.875 17.979C28.3194 17.7984 27.75 17.6665 27.1667 17.5832V7.45817H3.83333V30.7915H13.9167C14 31.4026 14.1319 31.9859 14.3125 32.5415C14.4931 33.0971 14.7083 33.6248 14.9583 34.1248H3.83333ZM3.83333 30.7915V7.45817V17.5832V17.4582V30.7915ZM7.16667 27.4582H13.9583C14.0417 26.8748 14.1736 26.3054 14.3542 25.7498C14.5347 25.1943 14.7361 24.6526 14.9583 24.1248H7.16667V27.4582ZM7.16667 20.7915H17.3333C18.2222 19.9582 19.2153 19.2637 20.3125 18.7082C21.4097 18.1526 22.5833 17.7776 23.8333 17.5832V17.4582H7.16667V20.7915ZM7.16667 14.1248H23.8333V10.7915H7.16667V14.1248ZM15.5 6.20817C15.8611 6.20817 16.1597 6.09011 16.3958 5.854C16.6319 5.61789 16.75 5.31928 16.75 4.95817C16.75 4.59706 16.6319 4.29845 16.3958 4.06234C16.1597 3.82623 15.8611 3.70817 15.5 3.70817C15.1389 3.70817 14.8403 3.82623 14.6042 4.06234C14.3681 4.29845 14.25 4.59706 14.25 4.95817C14.25 5.31928 14.3681 5.61789 14.6042 5.854C14.8403 6.09011 15.1389 6.20817 15.5 6.20817ZM25.5 37.4582C23.1944 37.4582 21.2292 36.6457 19.6042 35.0207C17.9792 33.3957 17.1667 31.4304 17.1667 29.1248C17.1667 26.8193 17.9792 24.854 19.6042 23.229C21.2292 21.604 23.1944 20.7915 25.5 20.7915C27.8056 20.7915 29.7708 21.604 31.3958 23.229C33.0208 24.854 33.8333 26.8193 33.8333 29.1248C33.8333 31.4304 33.0208 33.3957 31.3958 35.0207C29.7708 36.6457 27.8056 37.4582 25.5 37.4582ZM24.6667 34.1248H26.3333V29.9582H30.5V28.2915H26.3333V24.1248H24.6667V28.2915H20.5V29.9582H24.6667V34.1248Z" fill="#0777A9" />
                                                            </svg>
                                                        </span>
                                                        <h5 className='text-center' style={{ color: "#0777A9", fontWeight: '500', fontSize: "16px", lineHeight: '27px' }}>{img?.FileName}</h5>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                !disabled && onPhotoHover === img?.fieldname && (
                                                    <div key={img?.fieldname + 1} className="image_video_hover position-absolute rounded-pill py-1 text-center align-content-center">
                                                        <i className="fa-solid fa-trash-can" role='button' onClick={() => handleDeleteFile('PropertyDocumentFileName', 'PropertyDocumentFilePath', 'Document')}></i>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </Fragment>
                            )
                        })
                    }
                </div>
            </div>
            <div className='mt-3'>
                <h5>Owner Identity Proof</h5>
                <div className='row'>
                    <div className='col-xl-3 col-lg-4 col-md-6 col-12'>
                        <div className='h-241px' key={'OwnerIdentityProofFileName'}>
                            <UploadDocButton
                                mediaType={".png,.pdf"}
                                name={'Document'}
                                foldername={'Owner Identity Proof'}
                                iscollection={false}
                                maxfilesize={20}
                                Fieldname='OwnerIdentityProofFileName'
                                Fieldpath='OwnerIdentityProofFilePath'
                                hendlesetdoc={hendlesetdoc}
                                setImageSection={setImageSection}
                                formValue={formValue}
                                hotelId={hotelId}
                                disabled={disabled}
                                setSave={setSave}
                                setFormError={setFormError}
                            />
                        </div>
                        {formError?.OwnerIdentityProofFileName && <div className='text-danger'>{formError?.OwnerIdentityProofFileName}</div>}
                    </div>
                    {
                        imageSection?.filter(er => er.fieldname === 'OwnerIdentityProofFileName')?.map((img, index) => {
                            return (
                                <Fragment key={img?.fieldname + img?.FileName + index}>
                                    <div className='col-xl-3 col-lg-4 col-md-6 col-12'
                                        onMouseEnter={() => setOnPhotoHover(img?.fieldname)}
                                        onMouseLeave={() => setOnPhotoHover('')}
                                    >
                                        <div className='h-241px photo-images-card position-relative'>
                                            {doctest(img?.FileName) ?
                                                <img
                                                    className='rounded'
                                                    src={
                                                        img?.needToUpload ?
                                                            URL.createObjectURL(img?.File) :
                                                            `${CommonFileURLWithFolder}${img?.FilePath}`
                                                    }
                                                    alt={img?.FileName}
                                                    height={'100%'}
                                                    width={'100%'}
                                                    aspect-ratio={3 / 2}
                                                />
                                                :
                                                <div className='align-content-center px-auto photo-images-card' style={{ backgroundColor: '#0777a926', height: '100%', width: '100%' }} aspect-ratio={3 / 2}>
                                                    <div className='p-3'>
                                                        <span className='d-flex justify-content-center bg-transparent'>
                                                            <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M3.83333 34.1248C2.91667 34.1248 2.13194 33.7984 1.47917 33.1457C0.826389 32.4929 0.5 31.7082 0.5 30.7915V7.45817C0.5 6.5415 0.826389 5.75678 1.47917 5.104C2.13194 4.45123 2.91667 4.12484 3.83333 4.12484H10.8333C11.1944 3.12484 11.7986 2.31928 12.6458 1.70817C13.4931 1.09706 14.4444 0.791504 15.5 0.791504C16.5556 0.791504 17.5069 1.09706 18.3542 1.70817C19.2014 2.31928 19.8056 3.12484 20.1667 4.12484H27.1667C28.0833 4.12484 28.8681 4.45123 29.5208 5.104C30.1736 5.75678 30.5 6.5415 30.5 7.45817V18.6248C29.9722 18.3748 29.4306 18.1596 28.875 17.979C28.3194 17.7984 27.75 17.6665 27.1667 17.5832V7.45817H3.83333V30.7915H13.9167C14 31.4026 14.1319 31.9859 14.3125 32.5415C14.4931 33.0971 14.7083 33.6248 14.9583 34.1248H3.83333ZM3.83333 30.7915V7.45817V17.5832V17.4582V30.7915ZM7.16667 27.4582H13.9583C14.0417 26.8748 14.1736 26.3054 14.3542 25.7498C14.5347 25.1943 14.7361 24.6526 14.9583 24.1248H7.16667V27.4582ZM7.16667 20.7915H17.3333C18.2222 19.9582 19.2153 19.2637 20.3125 18.7082C21.4097 18.1526 22.5833 17.7776 23.8333 17.5832V17.4582H7.16667V20.7915ZM7.16667 14.1248H23.8333V10.7915H7.16667V14.1248ZM15.5 6.20817C15.8611 6.20817 16.1597 6.09011 16.3958 5.854C16.6319 5.61789 16.75 5.31928 16.75 4.95817C16.75 4.59706 16.6319 4.29845 16.3958 4.06234C16.1597 3.82623 15.8611 3.70817 15.5 3.70817C15.1389 3.70817 14.8403 3.82623 14.6042 4.06234C14.3681 4.29845 14.25 4.59706 14.25 4.95817C14.25 5.31928 14.3681 5.61789 14.6042 5.854C14.8403 6.09011 15.1389 6.20817 15.5 6.20817ZM25.5 37.4582C23.1944 37.4582 21.2292 36.6457 19.6042 35.0207C17.9792 33.3957 17.1667 31.4304 17.1667 29.1248C17.1667 26.8193 17.9792 24.854 19.6042 23.229C21.2292 21.604 23.1944 20.7915 25.5 20.7915C27.8056 20.7915 29.7708 21.604 31.3958 23.229C33.0208 24.854 33.8333 26.8193 33.8333 29.1248C33.8333 31.4304 33.0208 33.3957 31.3958 35.0207C29.7708 36.6457 27.8056 37.4582 25.5 37.4582ZM24.6667 34.1248H26.3333V29.9582H30.5V28.2915H26.3333V24.1248H24.6667V28.2915H20.5V29.9582H24.6667V34.1248Z" fill="#0777A9" />
                                                            </svg>
                                                        </span>
                                                        <h5 className='text-center' style={{ color: "#0777A9", fontWeight: '500', fontSize: "16px", lineHeight: '27px' }}>{img?.FileName}</h5>
                                                    </div>
                                                </div>
                                            }

                                            {
                                                !disabled && onPhotoHover === img?.fieldname && (
                                                    <div key={img?.fieldname + 1} className="image_video_hover position-absolute rounded-pill py-1 text-center align-content-center">
                                                        <i className="fa-solid fa-trash-can" role='button' onClick={() => handleDeleteFile('OwnerIdentityProofFileName', 'OwnerIdentityProofFilePath', 'Document')}></i>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </Fragment>
                            )
                        })
                    }
                </div>
            </div>
            <div className='mt-3'>
                <h5>GSTIN Detail</h5>
                <div className='row'>
                    <div className='col-auto align-content-center'><h6 className='mb-1'>Do you have GSTIN ?</h6></div>
                    <div className='col-auto d-flex'>
                        <FormControlLabel className=''
                            control={
                                <Radio
                                    checked={formValue?.IsGST === true}
                                    name='IsGST'
                                    onChange={(e) => handleChange(e.target.name, true)}
                                    value="true"
                                    id='Allowedid'
                                    inputProps={{ 'aria-label': 'true' }}
                                    disabled={disabled}
                                />
                            }
                            label="Yes"
                        />
                        <FormControlLabel className=''
                            control={
                                <Radio
                                    checked={formValue?.IsGST === false}
                                    onChange={(e) => {
                                        handleChange(e.target.name, false)
                                    }}
                                    value="false"
                                    id='NotAllowedid'
                                    name='IsGST'
                                    inputProps={{ 'aria-label': 'false' }}
                                    disabled={disabled}
                                />
                            }
                            label="No"
                        />
                    </div>
                    <div className='col-12'>
                        <div className='row'>
                            <div className='col-xl-3 col-lg-4 col-md-6 col-12'>
                                <FormControl className='w-100'>
                                    <TextField id='GSTNo' label='GSTIN Number'
                                        className={`w-100`}
                                        type="text"
                                        name='GSTNo'
                                        inputProps={{ maxLength: 15 }}
                                        value={formValue?.GSTNo}
                                        onChange={(e) => handleChange(e.target.name, alphaNumeric(e.target.value) === '' ? "" : alphaNumeric(e.target.value))}
                                        disabled={!formValue?.IsGST || disabled}
                                        error={formError?.GSTNo ? true : false}
                                        helperText={formError?.GSTNo}
                                    />
                                </FormControl>
                            </div>
                        </div>
                    </div>
                    <div className='col-xl-3 col-lg-4 col-md-6 col-12 mt-2'>
                        <div className='h-241px' key={'GSTFileName'}>
                            <UploadDocButton
                                mediaType={".png,.pdf"}
                                name={'Document'}
                                foldername={'GSTIN Detail'}
                                iscollection={false}
                                maxfilesize={20}
                                Fieldname='GSTFileName'
                                Fieldpath='GSTFilePath'
                                hendlesetdoc={hendlesetdoc}
                                setImageSection={setImageSection}
                                formValue={formValue}
                                hotelId={hotelId}
                                disabled={disabled}
                                setSave={setSave}
                                setFormError={setFormError}
                            />
                        </div>
                        {formError?.GSTFileName && <div className='text-danger'>{formError?.GSTFileName}</div>}
                        {formError?.GSTFilePath && <div className='text-danger'>{formError?.GSTFilePath}</div>}
                    </div>
                    {
                        imageSection?.filter(er => er.fieldname === 'GSTFileName')?.map((img, index) => {
                            return (
                                <Fragment key={img?.fieldname + img?.FileName + index}>
                                    <div className='col-xl-3 col-lg-4 col-md-6 col-12 mt-2'
                                        onMouseEnter={() => setOnPhotoHover(img?.fieldname)}
                                        onMouseLeave={() => setOnPhotoHover('')}
                                    >
                                        <div className='h-241px photo-images-card position-relative'>
                                            {doctest(img?.FileName) ?
                                                <img
                                                    className='rounded'
                                                    src={
                                                        img?.needToUpload ?
                                                            URL.createObjectURL(img?.File) :
                                                            `${CommonFileURLWithFolder}${img?.FilePath}`
                                                    }
                                                    alt={img?.FileName}
                                                    height={'100%'}
                                                    width={'100%'}
                                                    aspect-ratio={3 / 2}
                                                />
                                                :
                                                <div className='align-content-center px-auto photo-images-card' style={{ backgroundColor: '#0777a926', height: '100%', width: '100%' }} aspect-ratio={3 / 2}>
                                                    <div className='p-3'>
                                                        <span className='d-flex justify-content-center bg-transparent'>
                                                            <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M3.83333 34.1248C2.91667 34.1248 2.13194 33.7984 1.47917 33.1457C0.826389 32.4929 0.5 31.7082 0.5 30.7915V7.45817C0.5 6.5415 0.826389 5.75678 1.47917 5.104C2.13194 4.45123 2.91667 4.12484 3.83333 4.12484H10.8333C11.1944 3.12484 11.7986 2.31928 12.6458 1.70817C13.4931 1.09706 14.4444 0.791504 15.5 0.791504C16.5556 0.791504 17.5069 1.09706 18.3542 1.70817C19.2014 2.31928 19.8056 3.12484 20.1667 4.12484H27.1667C28.0833 4.12484 28.8681 4.45123 29.5208 5.104C30.1736 5.75678 30.5 6.5415 30.5 7.45817V18.6248C29.9722 18.3748 29.4306 18.1596 28.875 17.979C28.3194 17.7984 27.75 17.6665 27.1667 17.5832V7.45817H3.83333V30.7915H13.9167C14 31.4026 14.1319 31.9859 14.3125 32.5415C14.4931 33.0971 14.7083 33.6248 14.9583 34.1248H3.83333ZM3.83333 30.7915V7.45817V17.5832V17.4582V30.7915ZM7.16667 27.4582H13.9583C14.0417 26.8748 14.1736 26.3054 14.3542 25.7498C14.5347 25.1943 14.7361 24.6526 14.9583 24.1248H7.16667V27.4582ZM7.16667 20.7915H17.3333C18.2222 19.9582 19.2153 19.2637 20.3125 18.7082C21.4097 18.1526 22.5833 17.7776 23.8333 17.5832V17.4582H7.16667V20.7915ZM7.16667 14.1248H23.8333V10.7915H7.16667V14.1248ZM15.5 6.20817C15.8611 6.20817 16.1597 6.09011 16.3958 5.854C16.6319 5.61789 16.75 5.31928 16.75 4.95817C16.75 4.59706 16.6319 4.29845 16.3958 4.06234C16.1597 3.82623 15.8611 3.70817 15.5 3.70817C15.1389 3.70817 14.8403 3.82623 14.6042 4.06234C14.3681 4.29845 14.25 4.59706 14.25 4.95817C14.25 5.31928 14.3681 5.61789 14.6042 5.854C14.8403 6.09011 15.1389 6.20817 15.5 6.20817ZM25.5 37.4582C23.1944 37.4582 21.2292 36.6457 19.6042 35.0207C17.9792 33.3957 17.1667 31.4304 17.1667 29.1248C17.1667 26.8193 17.9792 24.854 19.6042 23.229C21.2292 21.604 23.1944 20.7915 25.5 20.7915C27.8056 20.7915 29.7708 21.604 31.3958 23.229C33.0208 24.854 33.8333 26.8193 33.8333 29.1248C33.8333 31.4304 33.0208 33.3957 31.3958 35.0207C29.7708 36.6457 27.8056 37.4582 25.5 37.4582ZM24.6667 34.1248H26.3333V29.9582H30.5V28.2915H26.3333V24.1248H24.6667V28.2915H20.5V29.9582H24.6667V34.1248Z" fill="#0777A9" />
                                                            </svg>
                                                        </span>
                                                        <h5 className='text-center' style={{ color: "#0777A9", fontWeight: '500', fontSize: "16px", lineHeight: '27px' }}>{img?.FileName}</h5>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                !disabled && onPhotoHover === img?.fieldname && (
                                                    <div key={img?.fieldname + 1} className="image_video_hover position-absolute rounded-pill py-1 text-center align-content-center">
                                                        <i className="fa-solid fa-trash-can" role='button' onClick={() => handleDeleteFile('GSTFileName', 'GSTFilePath', 'Document')}></i>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>

                                </Fragment>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default Legal